<template>
  <h3 class="font-semibold text-gray-700 text-xl">Exportable - Descarte</h3>
  <div id="chart5">
    <apexchart
      type="bar"
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessShowReportsGraphicsOkDiscardWeekly",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true },
    show_header: { default: true }
  },
  data() {
    return {};
  },
  computed: {
    series() {
      return [
        {
          name: "Exportable",
          data: this.data_accepted_weekly
        },
        {
          name: "Descarte",
          data: this.data_discarded_weekly
        }
      ];
    },
    options() {
      return {
        chart: {
          type: "bar",
          height: 350,
          stacked: true
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 2,
            dataLabels: {
              position: 'bottom',
              hideOverflowingLabels: false,
              offsetY: [0, 30],
              total: {
                enabled: false,
                style: { fontSize: "13px" }
              }
            }
          }
        },
        dataLabels: {
          formatter: function (val, { globals, dataPointIndex }) {
            const percent =
              (val /
                (globals.series[0][dataPointIndex] +
                  globals.series[1][dataPointIndex])) *
              100;
            return this.numberWithPrecision(percent, 1) + "%";
          }.bind(this),
          style: { colors: ["#65A30D", "#CC3333"] },
          background: {
            enabled: true,
            foreColor: "#fff",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 0,
          },
        },
        colors: ["#65A30D", "#CC3333"],
        xaxis: {
          tickPlacement: "between",
          group: {
            groups: this.groups,
            style: {
              fontSize: "14px",
              fontWeight: 500
            }
          }
        },
        yaxis: {
          title: { text: "Kilogramos" },
          tickPlacement: "between",
          labels: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this)
          }
        },
        tooltip: {
          x: {
            formatter: function (val) {
              return `Sem ${val}`;
            }
          }
        },
        legend: {
          position: "bottom"
        },
        fill: {
          opacity: 1
        }
      };
    },
    data_accepted_weekly() {
      return Object.values(this.data)
        .flat()
        .map(harvest => {
          return {
            x: `${harvest[0]}`,
            y: harvest[1]
          };
        });
    },
    data_discarded_weekly() {
      return Object.values(this.data)
        .flat()
        .map(harvest => {
          return {
            x: `${harvest[0]}`,
            y: harvest[2]
          };
        });
    },
    groups() {
      return Object.keys(this.data).map(key => {
        return {
          title: key,
          cols: this.data[key].length
        };
      });
    }
  },
  methods: {
    barWidth() {
      if (this.data.months.length < 20) return "20%";
      if (this.data.months.length < 30) return "50%";
      return "70%";
    }
  }
};
</script>
